import { Component, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BankAccountProxyService } from '../../../proxies/bank-account.proxy.service';
import { BankReconciliationProxyService } from '../../../proxies/bank-reconciliation.proxy.service';
import { BankAccount } from '../../../models/bank-account/bank-account';
import { ReconciliationMatch, ReconciliationResult } from '../../../models/bank-reconciliation/bank-reconciliation';

@Component({
  selector: 'app-bank-reconciliation',
  templateUrl: './bank-reconciliation.component.html',
  styleUrl: './bank-reconciliation.component.scss',
})
export class BankReconciliationComponent implements OnInit {
  bankAccounts = signal<BankAccount[]>([]);
  result = signal<ReconciliationResult | null>(null);
  selectedFile: File | null = null;
  selectedCandidates: ReconciliationMatch[] = [];
  isLoading = 0;

  filterForm = new FormGroup({
    accountId: new FormControl<string | null>(null, [Validators.required]),
  });

  constructor(
    private bankAccountService: BankAccountProxyService,
    private reconciliationService: BankReconciliationProxyService,
  ) {}

  ngOnInit(): void {
    this.loadAccounts();
  }

  private loadAccounts() {
    this.isLoading++;
    this.bankAccountService.getAll().subscribe({
      next: (response) => {
        this.bankAccounts.set(response.data ?? []);
        this.isLoading--;
      },
      error: (error) => {
        this.isLoading--;
        throw error;
      },
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files && input.files.length > 0 ? input.files[0] : null;
  }

  onUpload() {
    if (this.filterForm.invalid || !this.selectedFile) {
      this.filterForm.markAllAsTouched();
      return;
    }
    const accountId = this.filterForm.value.accountId!;
    this.isLoading++;
    this.reconciliationService.match(this.selectedFile, accountId).subscribe({
      next: (response) => {
        this.result.set(response.data ?? null);
        this.selectedCandidates = [];
        this.isLoading--;
      },
      error: (error) => {
        this.isLoading--;
        throw error;
      },
    });
  }

  confirmSelected() {
    const accountId = this.filterForm.value.accountId;
    if (!accountId || this.selectedCandidates.length === 0) return;
    this.isLoading++;
    this.reconciliationService
      .confirm({
        bankAccountId: accountId,
        matches: this.selectedCandidates
          .filter((c) => c.mt940Line?.reference)
          .map((c) => ({
            bankTransactionId: c.bankTransactionId,
            mt940Reference: c.mt940Line!.reference!,
          })),
      })
      .subscribe({
        next: () => {
          this.isLoading--;
          this.onUpload(); // refresh
        },
        error: (error) => {
          this.isLoading--;
          throw error;
        },
      });
  }
}
